export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7016.8d417ab0.jpg";